<template>
<div class="center">
<h1>ページが見つかりませんでした</h1>
</div>
</template>

<script>
export default {
  name: 'NotFoundPage',
}
</script>

<style scoped>
.center {
  text-align: center;
  position: relative;
  top: 45vh;
}
</style>